import { CatHeading } from '@blocks-react/components/Heading';
import { DIYVideoNotFoundProps } from "../types";


export const DIYVideoNotFound = ({
    description,
    children,
    variant,
    level

}: DIYVideoNotFoundProps) => {
    return (
        <>
            <CatHeading variant={variant} level={level}>
                {description}
            </CatHeading>
            {children}
        </>

    );
};
